export default __webpack_public_path__ + "static/media/img_02.f0a931c3.jpg";